<template>
  <li class="vue-tree-item"
      :class="{ bgw: depth > 0 }"
      :style="{ margin: depth == 1 ? '0 20px' : '' }">
    <div class="item-wrapper"
         :class="{ 'item-wrapper1': model.type == 1 }"
         :style="{
        paddingLeft: depth == 0 ? '40px' : '',
      }"
         onselectstart="return false;">
      <div class="isflex"
           style="flex: 1">
        <!-- checkbox -->
        <span v-if="options.checkbox"
              class="item-checkbox"
              :style="{
            cursor: disabled ? 'not-allowed' : '',
            color: labelStatus == 'unchecked' ? '' : 'var(--main-color)',
          }"
              style="font-size: 24px; "
              :class="[labelIcon, labelStatus]"
              @click="!disabled && toggleChecked()"></span>

        <!-- 折叠icon -->
        <div class="iconAndLabel "
             :style="{ paddingLeft: depth * 24 + 'px' }">
          <span v-if="isFolder"
                class="item-toggle mx-2"
                @click="toggle">
            <v-icon size="28">{{ toggleIcon }}</v-icon>
          </span>
          <span v-else
                class="item-toggle mx-2"></span>
          <!-- label -->
          <v-sheet class="d-flex align-center">
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                             icon-class="diamond02"
                             v-if="model.type == 3"></mrc_ess_svgIcon>
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px;color:rgba(0,0,0,.6)"
                             icon-class="mouseButton"
                             fill="rgba(0, 0, 0, 0.6)"
                             v-if="model.type == 4"></mrc_ess_svgIcon>
            <span class="item-label"
                  :class="isBold"
                  @click="handle">
              {{ INT(model[options.label]) }}
            </span>
          </v-sheet>
        </div>
      </div>
      <v-sheet width="150"
               class="pr-8 d-flex align-center"
               v-if="model.client_type_uuid"
               :style="{ paddingRight: depth == 0 ? '50px' : '30px' }">
        <template v-for="item in splitString(model.client_type_uuid)">
          <mrc_ess_svgIcon :key="item"
                           style="font-size: 24px;margin-right: 5px"
                           :icon-class="item"></mrc_ess_svgIcon>
        </template>
        <template v-for="(item, index) in 4 -
            splitString(model.client_type_uuid).length">
          <i style="line-height: 44px"
             class="material-icons text--secondary"
             :key="index">maximize</i>
        </template>
      </v-sheet>
    </div>
    <v-divider v-if="model.type == 2"></v-divider>
    <ul v-if="isFolder"
        v-show="open"
        class="vue-tree-list"
        :style="{ paddingLeft: 0, paddingBottom: '10px' }">
      <tree-item v-for="(item, idx) in model.sub"
                 :model="item"
                 :options="options"
                 :ids="ids"
                 :depth="depth + 1"
                 :ids-with-parent="idsWithParent"
                 :half="half"
                 :disabled="disabled"
                 :state="itemState"
                 :key="idx"
                 @handle="emitHandle"
                 @child-change="childChange" />
    </ul>
  </li>
</template>
<script>
export default {
  name: 'tree-item',

  props: {
    model: {
      type: Object,
      default: function () {
        return {}
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Object,
      default: function () {
        return {}
      },
    },

    depth: {
      type: Number,
      default: 0,
    },

    ids: {
      type: Array,
      default: function () {
        return []
      },
    },

    idsWithParent: {
      type: Array,
      default: function () {
        return []
      },
    },
    //  这是父级id
    half: {
      type: Array,
      default: function () {
        return []
      },
    },

    state: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      open: false,
      // 这个值有点重要
      itemState: 0,
    }
  },

  computed: {
    toggleIcon () {
      return this.open ? this.options.closeIcon : this.options.openIcon
    },

    labelIcon () {
      if (this.half.indexOf(this.model.uuid) !== -1) {
        return this.options.halfCheckedIcon
      } else if (this.idsWithParent.indexOf(this.model.uuid) !== -1) {
        return this.options.checkedIcon
      } else {
        return this.options.uncheckedIcon
      }
    },

    labelStatus () {
      if (this.half.indexOf(this.model.uuid) !== -1) {
        return 'half-checked'
      } else if (this.idsWithParent.indexOf(this.model.uuid) !== -1) {
        return 'checked'
      } else {
        return 'unchecked'
      }
    },
    // 有子级 子级的个数
    isFolder () {
      return this.model.sub && this.model.sub.length
    },

    isBold () {
      return {
        'item-bold': this.isFolder && this.options.folderBold,
      }
    },

    self () {
      let self = Object.assign({}, this.model, { children: [] })
      delete self.children
      return self
    },
  },

  created () {
    // console.log(this.ids)
    if (this.options.checkbox) {
      if (this.idsWithParent.indexOf(this.model.uuid) !== -1) {
        this.itemState = this.itemState + 1
        this.$emit('child-change', true)
      }
      //
      if (this.state > 0) {
        this.addChecked()
        this.itemState = this.itemState + 1
      }
    }
  },

  watch: {
    ids: {
      handler () { },
    },
    state (val, old) {
      if (val > old) {
        this.addChecked()
        this.itemState = this.itemState + 1
      } else {
        this.delChecked()
        this.deleteHalfChecked(this.model.uuid)
        this.itemState = this.itemState - 1
      }
    },
  },

  methods: {
    splitString (str) {
      let arr = []
      if (str) {
        if (str.indexOf(',') > -1) {
          str.split(',').forEach((item) => {
            arr.push(item)
          })
        } else {
          arr = [str]
        }
      }
      return arr
    },
    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },

    handle () {
      this.emitHandle(this.self)
    },

    emitHandle (item) {
      this.$emit('handle', item)
    },

    toggleChecked () {
      if (this.isFolder) {
        this.deleteHalfChecked()
      }
      if (this.idsWithParent.indexOf(this.model.uuid) !== -1) {
        this.delChecked()
        this.$emit('child-change', false)
        this.itemState = this.itemState - 1
      } else {
        this.addChecked()
        this.$emit('child-change', true)
        // if (this.options.checkedOpen && this.isFolder) {
        //   this.open = true
        // }
        this.itemState = this.itemState + 1
      }
    },

    addChecked () {
      // 如果 当前的uuid 不在选中的idsWithParent里面  就添加进里面
      if (this.idsWithParent.indexOf(this.model.uuid) === -1) {
        this.$set(
          this.idsWithParent,
          this.idsWithParent.length,
          this.model.uuid
        )
      }
      // 如果没有子级 或者 选了父级的id  就将id放到ids里面去
      if (!this.isFolder || this.options.idsWithParent) {
        if (this.ids.indexOf(this.model.uuid) === -1) {
          this.$set(this.ids, this.ids.length, this.model.uuid)
        }
      }
    },
    // 将本身的uuid从 全部uuid里面删除
    delChecked () {
      // console.log('delChecked')
      let idx = this.idsWithParent.indexOf(this.model.uuid)
      let index = this.ids.indexOf(this.model.uuid)
      if (idx !== -1) {
        this.$delete(this.idsWithParent, idx)
      }
      if (index !== -1) {
        this.$delete(this.ids, index)
      }
    },

    setHalfChecked () {
      // 本身uuid 不在half 里面 就加进去
      if (this.half.indexOf(this.model.uuid) === -1) {
        this.$set(this.half, this.half.length, this.model.uuid)
      }
    },

    deleteHalfChecked () {
      // console.log('deleteHalfChecked')
      let idx = this.half.indexOf(this.model.uuid)
      if (idx !== -1) {
        this.$delete(this.half, idx)
      }
    },

    childChange (checked) {
      // console.log('childChange')
      // 如果 循环model的数据  父节点uuid 在half里面
      if (this.model.sub.some((val) => this.half.indexOf(val.uuid) !== -1)) {
        this.addChecked()
        this.setHalfChecked()
        this.$emit('child-change', true)
        return
      }
      // 父节点uuid不在half里面
      if (checked) {
        // 将自身uuid加入ids 和 idsWithParent
        this.addChecked()
        // 如果idsWithParent 里面没有 children 的uuid 就 把本身的uuid加入idsWithParent
        if (
          this.model.sub.some(
            (val) => this.idsWithParent.indexOf(val.uuid) === -1
          )
        ) {
          this.setHalfChecked()
        } else {
          this.deleteHalfChecked()
        }
        this.$emit('child-change', true)
      } else {
        // 全部id里面有 自身的uuid
        if (
          this.model.sub.some(
            (val) => this.idsWithParent.indexOf(val.uuid) !== -1
          )
        ) {
          this.setHalfChecked()
        } else {
          this.deleteHalfChecked()
          this.delChecked()
        }
        this.$emit('child-change', false)
      }
    },
  },
}
</script>
<style scoped>
.bgw {
  background-color: #fff;
}
</style>
